import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GuideStepEnum, NotificationModel, initialState } from './mainModel';
import { RootStoreType } from '../rootReducer';
import { AppConfig, User } from '../../@shared/Models/Models';

const statesSlice = createSlice({
    name: 'mainReducer',
    initialState: initialState.mainModel,
    reducers: {
        setIsShowMainLoader: (state, action: PayloadAction<boolean>) => {
            state.isShowMainLoader = action.payload;
        },
        addAlert: (state, action: PayloadAction<NotificationModel>) => {
            state.alerts.push(action.payload);
        },
        markAsClosedError: (state, action: PayloadAction<Date>) => {
            state.alerts.map(x => {
                if (x.date === action.payload) {
                    x.markAsClosed = true;
                }
                return x;
            });
        },
        removeError: (state, action: PayloadAction<Date>) => {
            state.alerts = state.alerts.filter(x => x.date !== action.payload);
        },
        setIsAuthorized: (state, action: PayloadAction<User | undefined>) => {
            state.isAuthorized = action.payload;
        },
        setUserIsLoading: (state, action: PayloadAction<boolean>) => {
            state.userIsLoading = action.payload;
        },
        setAppConfig: (state, action: PayloadAction<AppConfig>) => {
            state.appConfig = action.payload;
        },
        setSeats: (state, action: PayloadAction<User[]>) => {
            state.seats = action.payload;
        },
        setSeatsIsLoading: (state, action: PayloadAction<boolean>) => {
            state.seatsIsLoading = action.payload;
        },
        setGuideStep: (state, action: PayloadAction<GuideStepEnum>) => {
            state.guideStep = action.payload;
        }
    }
});

export const {
    setIsShowMainLoader,
    addAlert,
    removeError,
    setIsAuthorized,
    setUserIsLoading,
    markAsClosedError,
    setAppConfig,
    setSeats,
    setSeatsIsLoading,
    setGuideStep
} = statesSlice.actions;

//selectors
export const getIsShowMainLoader = (store: RootStoreType): boolean => store.main.mainModel.isShowMainLoader;
export const getError = (store: RootStoreType): NotificationModel[] => store.main.mainModel.alerts;
export const getIsAuthorized = (store: RootStoreType): User | undefined => store.main.mainModel.isAuthorized;
export const getUserIsLoading = (store: RootStoreType): boolean => store.main.mainModel.userIsLoading;
export const getAppConfig = (store: RootStoreType): AppConfig => store.main.mainModel.appConfig;
export const getSeats = (store: RootStoreType): User[] => store.main.mainModel.seats;
export const getSeatsIsLoading = (store: RootStoreType): boolean => store.main.mainModel.seatsIsLoading;
export const getGuideStep = (store: RootStoreType): GuideStepEnum => store.main.mainModel.guideStep;
export default statesSlice.reducer;